import React from 'react';
import { Box } from '@chakra-ui/react';

import StatusButton from '../../../../../../../../../../components/StatusButton';
import { getStatusButtonMenuOptions } from '../../../../../../../../../../components/StatusButton/reactQueryUtil';
import { CypressIds } from '../../../../../../../../../../constants/cypressIds';
import { Statuses } from '../../../../../../../../../../constants/statuses';
import { useDeletePolicy, useReactivatePolicy } from '../../../../../../../../../../services/policy-service';

import EffectiveDateCell from './EffectiveDateCell';

export const COLUMNS = [
  {
    Header: 'Policy Type',
    accessor: 'insurancePolicyType.displayName',
    Cell: ({ cell: { value }, row: { original } }) => (<Box data-cy={CypressIds.archivedPolicyRow(original.id)}>{value}</Box>)
  },
  {
    Header: 'Policy Number',
    accessor: 'number'
  },
  {
    Header: 'Insurance Company',
    accessor: 'insuranceCompany.companyName',
    Cell: ({ cell: { value }, row: { original } }) => (
      <Box color="success.primary.600">
        <a
          href="http://www3.ambest.com/ratings/entities/SearchResults.aspx?AltSrc=9"
          rel="noreferrer"
          target="_blank"
        >
          {value}
        </a>
      </Box>
    )
  },
  {
    Header: 'Effective Dates',
    accessor: policy => ({
      effectiveAt: policy.effectiveAt,
      expiresAt: policy.expiresAt
    }),
    Cell: EffectiveDateCell
  },
  {
    Header: 'Options',
    accessor: 'status',
    Cell: ({ cell: { value }, row: { original } }) => {
      const { insuredId, jobId, recordId, id: policyId, insurancePolicyTypeId: policyTypeId } = original;
      const { mutate: reactivatePolicy } = useReactivatePolicy({
        policyId,
        policyTypeId,
        insuredId,
        jobId,
        recordId
      });
      const { mutate: deletePolicy } = useDeletePolicy({
        policyId,
        policyTypeId,
        insuredId,
        jobId,
        recordId
      });
      const options = getStatusButtonMenuOptions(Statuses.Archived, 'requirements');

      return (
        <StatusButton
          cypressId={CypressIds.archivedPolicyStatusButton(original.id)}
          id={original.id}
          metadata={{
            policyId: original.id,
            reactivatePolicy,
            deletePolicy
          }}
          options={options}
        />
      );
    }
  }
];
